import type { UscFinanceInfoType } from "../../../shared-logic/types/UscCommonTypes";
import type {
    StockFinancePayload,
    UscFinanceAccessoryType,
    UscFinanceCostType,
    UscFinanceResponseDebugType,
    UscFinanceServiceType,
    UsedFinanceInsurancePayload,
    UsedFinanceInsurancePayloadV2,
} from "../../utils/financeUtils";

export const USC_FINANCE_SET_INFO = "finance/setFinanceInfo";
export const USC_FINANCE_SET_QUOTE_ID = "finance/setQuoteId";
export const USC_FINANCE_SET_FAILED = "finance/setFetchFailed";
export const USC_FINANCE_START_FETCH = "finance/startFetch";

export type SetFinanceInfo = {
    type: typeof USC_FINANCE_SET_INFO;
    payload: UsedFinanceInsurancePayload | UsedFinanceInsurancePayloadV2 | StockFinancePayload | null;
    info: UscFinanceInfoType | null;
    financeQuoteId: string | null;
    monthlyPrice: number;
    accessories: UscFinanceAccessoryType[];
    services: UscFinanceServiceType[];
    costs: UscFinanceCostType[];
    response: UscFinanceResponseDebugType | null;
};

export type SetFinanceQuoteId = {
    type: typeof USC_FINANCE_SET_QUOTE_ID;
    financeQuoteId: string;
};

type SetFinanceFetchFailed = {
    type: typeof USC_FINANCE_SET_FAILED;
    failed: boolean;
    payload: UsedFinanceInsurancePayload | StockFinancePayload | null;
};

export type StartFetchType = {
    type: typeof USC_FINANCE_START_FETCH;
};

export const setFinanceInfo = (
    info: UscFinanceInfoType | null,
    monthlyPrice: number,
    payload: UsedFinanceInsurancePayload | UsedFinanceInsurancePayloadV2 | StockFinancePayload | null = null,
    response: UscFinanceResponseDebugType | null,
    financeQuoteId: string | null = null,
    accessories: UscFinanceAccessoryType[] = [],
    services: UscFinanceServiceType[] = [],
    costs: UscFinanceCostType[] = [],
): SetFinanceInfo => ({
    type: USC_FINANCE_SET_INFO,
    payload,
    info,
    financeQuoteId,
    monthlyPrice,
    accessories,
    services,
    costs,
    response,
});

export const setFinanceQuoteId = (financeQuoteId: string): SetFinanceQuoteId => ({
    type: USC_FINANCE_SET_QUOTE_ID,
    financeQuoteId,
});

export const setFinanceFetchFailed = (
    failed: boolean,
    payload: UsedFinanceInsurancePayload | StockFinancePayload,
): SetFinanceFetchFailed => ({
    type: USC_FINANCE_SET_FAILED,
    failed,
    payload,
});

export const startFinanceFetch = (): StartFetchType => ({
    type: USC_FINANCE_START_FETCH,
});

export type UscFinanceActionsType = SetFinanceInfo | SetFinanceQuoteId | SetFinanceFetchFailed | StartFetchType;
